<template>
<v-flex>
  <v-layout>
    <v-flex xs8>
      <v-text-field type="text" :label="`${index +1}) ${label}`" :value="data.name" :rules="nameRules" @change="update({name: $event})" />
    </v-flex>
    <v-flex xs1>
      <description :fieldName="data.name" :id="data.id" :description="data.description" @update="updateDescription($event)" @updateImages="updateOptions"></description>
    </v-flex>
    <v-flex xs1>
      <v-dialog width="900" v-model="optionsDialog">
        <v-btn fab dark color="indigo" slot="activator">
          <v-icon>settings</v-icon>
        </v-btn>
        <v-card>
          <v-card-title class="headline" primary-title>
            {{ label }} - {{ $t('schema.builder.options') }}
          </v-card-title>

          <v-divider></v-divider>

          <component :is="data.type + '-options'" :id="data.id" :context="context" :key="data.id + '-options'" :options="data.options || {}" @update="updateOptions"></component>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="optionsDialog = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs1>
      <v-btn fab dark color="warning" @click="destroy">
        <v-icon>delete_forever</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</v-flex>
</template>

<script>
import TextOptions from './options/TextOptions'
import NumberOptions from './options/NumberOptions'
import DateOptions from './options/DateOptions'
import TimeOptions from './options/TimeOptions'
import MultipleOptions from './options/MultipleOptions'
import SignatureOptions from './options/SignatureOptions'
import FormuleOptions from './options/FormuleOptions'
import PhotoOptions from './options/PhotoOptions'
import CodeOptions from './options/CodeOptions'
import ArchiveOptions from './options/ArchiveOptions'
import RelatedOptions from './options/RelatedOptions'
import SelectDependOptions from './options/SelectDependOptions'
import StorageOptions from './options/StorageOptions'
import Description from './Description'
import field from '@/mixins/field'
import GeolocationOptions from "./options/GeolocationOptions.vue";

export default {
  components: {
    Description,
    "number-options": NumberOptions,
    "text-options": TextOptions,
    "date-options": DateOptions,
    "time-options": TimeOptions,
    "multiple-options": MultipleOptions,
    "signature-options": SignatureOptions,
    "photo-options": PhotoOptions,
    "code-options": CodeOptions,
    "formule-options": FormuleOptions,
    "archive-options": ArchiveOptions,
    "related-options": RelatedOptions,
    "depend-options": SelectDependOptions,
    "storage-options": StorageOptions,
    "geolocation-options": GeolocationOptions
  },
  mixins: [field],
  props: ["data", "index"],
  data() {
    return {
      optionsDialog: false
    }
  },
  computed: {
    label() {
      switch (this.data.type) {
        case 'text':
          return this.$t('schema.builder.inputs.text-field')
        case 'number':
          return this.$t('schema.builder.inputs.number-field')
        case 'date':
          return this.$t('schema.builder.inputs.date-field')
        case 'time':
          return this.$t('schema.builder.inputs.time-field')
        case 'multiple':
          return this.$t('schema.builder.inputs.multiple-field')
        case 'signature':
          return this.$t('schema.builder.inputs.signature-field')
        case 'photo':
          return this.$t('schema.builder.inputs.photo-field')
        case 'code':
          return this.$t('schema.builder.inputs.code-field')
        case 'formule':
          return this.$t('schema.builder.inputs.formule')
        case 'archive':
          return this.$t('schema.builder.archive')
        case 'related':
          return this.$t('schema.builder.inputs.related-field')
        case 'depend':
          return this.$t('schema.builder.inputs.select-depend-field')
        case 'storage':
          return this.$t('schema.builder.inputs.storage-field')
        case 'geolocation':
          return this.$t('schema.builder.inputs.geolocation-field')
      }
    }
  },
  methods: {
    updateOptions(payload) {
      this.$store.commit("updateFieldOptions", payload)
    },
    updateDescription(description) {
      let payload = {
        id: this.data.id,
        description
      }
      this.$store.commit("updateFieldDescription", payload)
    },
    update(payload) {
      payload['id'] = this.data.id
      this.$store.commit("updateField", payload)
    },
    destroy() {
      this.$store.commit("removeField", this.index)
    }
  }
}
</script>
